export default "__VITE_ASSET__DsNOOb1S__"